// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { CommonModule } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SystemDetailsModel } from 'src/app/api/remote-api/.portal.generated/models';
import { ScreenLayoutService } from 'src/app/modules/shared/services/screen-layout-service/screen-layout.service';
import {
  DnaSyngoviaHealthcheckData,
  DnaSyngoviaServerHealthcheck,
} from '../../interfaces/dna-syngovia-healthcheck-data';
import { DnaSyngoviaServerNode } from '../../interfaces/dna-syngovia-node';
import { DnaSyngoviaCarouselComponent } from '../dna-syngovia-carousel/dna-syngovia-carousel.component';
import { DnaSyngoviaHealthcheckIssuesTableComponent } from '../dna-syngovia-healthcheck-issues-table/dna-syngovia-healthcheck-issues-table.component';
import { DnaSyngoviaHealthcheckSummaryComponent } from '../dna-syngovia-healthcheck-summary/dna-syngovia-healthcheck-summary.component';
import { DnaSyngoviaService } from '../../services/dna-syngovia.service';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    DnaSyngoviaHealthcheckSummaryComponent,
    DnaSyngoviaHealthcheckIssuesTableComponent,
    DnaSyngoviaCarouselComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  selector: 'app-dna-syngovia-healthcheck',
  templateUrl: './dna-syngovia-healthcheck.component.html',
  styleUrls: ['./dna-syngovia-healthcheck.component.scss'],
})
export class DnaSyngoviaHealthcheckComponent implements OnChanges, OnInit {
  @Input({ required: true }) systemDetails!: SystemDetailsModel;
  @Input({ required: true }) healthcheckData!: DnaSyngoviaHealthcheckData;
  @Input() selectedServer: DnaSyngoviaServerNode | undefined;

  protected selectedServerHealthcheck: DnaSyngoviaServerHealthcheck | undefined;

  public constructor(
    protected readonly screenLayoutService: ScreenLayoutService,
    private readonly dnaSyngoviaService: DnaSyngoviaService,
    private readonly changeDetectorRef: ChangeDetectorRef,
  ) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['healthcheckData']) {
      const serialNumber =
        this.dnaSyngoviaService.selectedServerHealthcheck ??
        this.systemDetails.systemSerialNumber;

      this.initSelectedServerHealthcheck(serialNumber);
    }
  }

  public ngOnInit(): void {
    this.clickOnSelectedCard();
  }

  private initSelectedServerHealthcheck(systemSerialNumber: string) {
    this.selectedServerHealthcheck =
      this.healthcheckData.serversHealthcheck.find(
        (serversHealthcheck) =>
          serversHealthcheck.serialNumber === systemSerialNumber
      );

    this.changeDetectorRef.detectChanges();
  }

  protected onSelectServerHealthcheck(
    serverHealthcheck: DnaSyngoviaServerHealthcheck
  ): void {
    this.selectedServerHealthcheck = serverHealthcheck;
  }

  private clickOnSelectedCard() {
    if (this.selectedServerHealthcheck) {
      const selectedCard = document.querySelector(
        '.server-card--selected'
      ) as HTMLElement;

      if (selectedCard) {
        selectedCard.click();
      }
    }
  }
}
